module.exports = __webpack_public_path__ + "img/counter-board-bg.d37bdfde.jpg";